import React, { Component } from "react";
import "./Educations.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio";
import { Fade } from "react-reveal";
import { withTranslation } from 'react-i18next';

class Educations extends Component {
  render() {
    const theme = this.props.theme;
    const { t } = this.props;
    return (
      <div className="main" id="educations">
        <div className="educations-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="educations-header" style={{ color: theme.text }}>
              {t('education.header')}
            </h1>
          </Fade>
        </div>
        <div className="educations-body-div">
          {degrees.degrees.map((degree, index) => {
            const degreeKey = index === 0 ? 'master' : 'bachelor';
            return <DegreeCard degreeKey={degreeKey} degree={degree} theme={theme} key={degreeKey} />;
          })}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Educations);
